// @ts-nocheck
/* eslint-disable */
export const starIcon = {
    data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0001 14.808L15.1501 17.9163L13.7834 12.058L18.3334 8.11634L12.3417 7.60801L10.0001 2.08301L7.65841 7.60801L1.66675 8.11634L6.21675 12.058L4.85008 17.9163L10.0001 14.808Z" fill="currentColor"/></svg>`,
    name: 'star' as const
};